export default __webpack_public_path__ + "static/media/dribbble-square.3cd4d342.svg";